import React, { useState } from 'react';
import './styles/StarRating.css';

const StarRating = ({ initialRating, onRate, readOnly }) => {
  const [rating, setRating] = useState(initialRating);
  const [hoverRating, setHoverRating] = useState(0);


  const handleClick = (rating) => {
    if (!readOnly && onRate) {
      onRate(rating);
    }
  };

  const handleMouseOver = (value) => {
    setHoverRating(value);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  /*
  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <span
          key={star}
          className={`star ${(hoverRating || rating) >= star ? 'filled' : ''}`}
          onClick={() => handleClick(star)}
          onMouseOver={() => handleMouseOver(star)}
          onMouseLeave={handleMouseLeave}
        >
          ★
        </span>
      ))}
      <div className="rating-text">
        Note : {rating}/5
      </div>
    </div>
  );*/
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
        <span
            key={i}
            onClick={() => handleClick(i)}
            style={{ cursor: readOnly ? 'default' : 'pointer', color: i <= initialRating ? '#FFD700' : '#ccc' }}
        >
        ★
      </span>
    );
  }

  return <div>{stars}</div>;
};

export default StarRating;